import { useState } from "react";
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from "recharts";
import { ETICHETTE } from "@/data/simulatorCopy";

const Tick = ({ x, y, payload, textAnchor, fontSize }) => {
  const lines = payload.value.split(" ");
  return (
    <text x={x} y={y} textAnchor={textAnchor} fill="#8a8f98" fontSize={fontSize} fontWeight={500}>
      {lines.map((l, i) => (
        <tspan key={l} x={x} dy={i ? "1.15em" : lines.length > 1 ? "-0.25em" : "0.35em"}>{l}</tspan>
      ))}
    </text>
  );
};

export const ResultRadar = ({ scores }) => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const [fontSize] = useState(() => (window.matchMedia("(min-width: 640px)").matches ? 13.5 : 12));
  return (
    <div className="min-w-0">
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-cyan">{ETICHETTE.eyebrow}</p>
      <div className="sim-radar mt-2 w-full h-[320px] sm:h-[420px] lg:h-[440px]" data-testid="sim-radar">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={scores} outerRadius="80%" margin={{ top: 12, right: 46, bottom: 12, left: 46 }}>
            <PolarGrid stroke="#1f2227" />
            <PolarAngleAxis dataKey="label" tick={<Tick fontSize={fontSize} />} />
            <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
            <Radar dataKey="display" stroke="#00e5ff" strokeWidth={2.5} fill="#00e5ff" fillOpacity={0.25} dot={{ r: 4, fill: "#00e5ff", strokeWidth: 0 }} isAnimationActive={!reduce} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 gap-2 font-mono text-xs">
        {scores.map((s) => (
          <div key={s.key} className="rounded-lg border border-[#1e2024] px-3 py-2 flex justify-between gap-2" data-testid={`sim-score-${s.key}`}>
            <span className="text-titanium truncate">{s.label}</span>
            <span className="text-white">{s.display}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
